import { render } from "./App.vue?vue&type=template&id=945bf6f2"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=945bf6f2&lang=scss"

import exportComponent from "/Users/patrikhubner/Dropbox/htdocs/netartmarathon/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__